import en from './en.json';
import pt from './pt.json';

const Languages = [
	{ code: 'en', label: 'English', value: en },
	{ code: 'pt', label: 'Português', value: pt },
];

export default Languages;
